import {
  QueryClient as ReactQueryClient,
  QueryClientProvider as ReactQueryClientProvider,
} from '@tanstack/react-query';

export const defaultQueryClient = new ReactQueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (failureCount > 5 || error?.response?.status < 500) {
          return false;
        }

        return window.__HB_ENV__.ENVIRONMENT === 'production';
      },
      // Never refetch the data if we refocus the window
      refetchOnWindowFocus: false,
    },
  },
});

const QueryClientProvider = ({
  children,
  queryClient = defaultQueryClient,
}) => (
  <ReactQueryClientProvider client={queryClient}>
    {children}
  </ReactQueryClientProvider>
);

export default QueryClientProvider;
